import apiClient from './apiClient';

export async function listNotifications(filters = {}) {
  const res = await apiClient.get('/notifications', { params: filters });
  return res.data.data.items;
}
export async function getUnreadCount() {
  const res = await apiClient.get('/notifications/unread-count');
  return res.data.data.count;
}
export async function markRead(notificationId) {
  await apiClient.patch(`/notifications/${notificationId}/read`);
}
export async function markAllRead() {
  await apiClient.post('/notifications/mark-all-read');
}
